import { FileUpload } from 'primereact/fileupload';
import { InputTextarea } from 'primereact/inputtextarea';
import React from 'react'
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { Api } from '../../services/api';
import { useEffect, useRef, useState } from "react";
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import axios from 'axios';
import * as Yup from 'yup';
import { Dropdown } from 'primereact/dropdown';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';
import { ProgressBar } from 'primereact/progressbar';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { useLocation, useNavigate } from 'react-router-dom';


function Help() {
    const navigate = useNavigate();
    const toast = useRef(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [orgType, setOrgType] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [globalFilter, setGlobalFilter] = useState('');
    const [searchOrgType, setSearchOrgType] = useState([]);

    const [orgShow, setOrgShow] = useState("N");
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [images, setImages] = useState([]);

    //* ----------------
    /** search Filtter function Start */

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        team_member_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        supervisor_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        quater: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
        year: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            team_member_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            supervisor_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            quater: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            year: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
        });
        setGlobalFilterValue('');
    };

    /** search Filtter function End */
    //! ----------------

    const toProperCase = (str) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };


    // Define priority and status options
    const priorityOptions = [
        { label: 'Low', value: 'low' },
        { label: 'Medium', value: 'medium' },
        { label: 'High', value: 'high' }
    ];

    const formik = useFormik({
        initialValues: {
            issue: '',
            description: '',
            attachment: '',
            images: [],
            priority: null,
        },

        validationSchema: Yup.object({
            issue: Yup.string()
                .required('Issue is required'),
            description: Yup.string()
                .required('Description is required'),
            // images: Yup.array()
            //     .min(1, 'At least one file is required'),
        }),
        onSubmit: (values) => {

            const errors = formik.errors;
            if (Object.keys(errors).length > 0) {
                const errorMessages = Object.values(errors).join(', ');
                toast.current.show({ severity: 'error', summary: 'Error', detail: errorMessages });
                return;
            }

            const token = localStorage.getItem('authToken');
            const headers = {
                'Authorization': token ? `Bearer ${token}` : ''
            };

            const formData = new FormData();
            values.images.forEach((file) => {
                formData.append('attachments', file);
            });
            formData.append('issue', values.issue);
            formData.append('description', values.description);
            formData.append('priority', values.priority);


            var url = Api.API_BASE_URL + 'help/save';

            fetch(url, {
                method: "POST",
                headers: headers,
                body: formData,
            })
                .then((response) => response.json())
                .then((Josn) => {

                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        getOrgType();
                        formik.resetForm(); 
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        },
    });


    //* -------Upload File---------------------

    const customBase64Uploader = async (event) => {
        // Access the selected files from the event
        const files = event.files; // This should be defined as event.files

        if (files) {
            setSelectedFiles(files); // Set the selected files

            const images = [];
            files.forEach((file) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    images.push(reader.result);
                    formik.setFieldValue('images', [...formik.values.images, file]); // Set the selected files in Formik
                };
                reader.readAsDataURL(file);
            });
        }
    };

    const [totalSize, setTotalSize] = useState(0);
    const fileUploadRef = useRef(null);

    const onTemplateUpload = (e) => {
        let _totalSize = 0;

        e.files.forEach((file) => {
            _totalSize += file.size || 0;
        });

        setTotalSize(_totalSize);
        toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
    };

    const onTemplateRemove = (file, callback) => {
        setTotalSize(totalSize - file.size);
        callback();
    };

    const onTemplateClear = () => {
        setTotalSize(0);
    };

    const headerTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        const value = totalSize / 10000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{ display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                <div className="flex align-items-center gap-3 ml-auto">
                    <span>{formatedValue} / 1 MB</span>
                    <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar>
                </div>
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="flex  align-items-center w-full" >
                <div className="" style={{ width: 'full' }}>
                    <img alt={file.name} role="presentation" src={file.objectURL} width={150} height={150} />

                </div>

                <span className="flex flex-column text-left p-4">
                    {file.name}
                    <small>{new Date().toLocaleDateString()}</small>
                </span>
                <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={() => onTemplateRemove(file, props.onRemove)} />
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column" style={{ width: '100%' }}>
                <i className="pi pi-image mt-3 p-5"
                    style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)', }}
                ></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Drag and Drop Image Here
                </span>
            </div>
        );
    };


    //! ----------------------------
    //* ---------- table------------------

    useEffect(() => {
        console.log('Fetching projects...xx');
        var organizationId = localStorage.getItem('organizationId');
        if (organizationId == "66f6989c2191596fe7f1c46f" || organizationId == "66f16bb68657dd00c9332538" || organizationId == "66ff87b2ef7cbfb759f2ff03") {
            setOrgShow("Y");

        }
        getOrgType();
        initFilters();
    }, []);

    const getOrgType = (project) => {
        const token = localStorage.getItem('authToken');

        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };

        axios.get(Api.API_BASE_URL + 'help/get', { headers })
            .then((response) => {
                const data = response.data.result;
                setOrgType(data);
                setSearchOrgType(data);
                setIsLoading(false);


                //* --------------------------
                let playbookRedirect = localStorage.getItem('quarterlyHuddleConRedirect');
                if (playbookRedirect) {
                    playbookRedirect = JSON.parse(playbookRedirect)
                    setFirst(playbookRedirect.first || 0)
                    setRows(playbookRedirect.rows || 12)
                    setSortField(playbookRedirect.sortField || 'quater')
                    setSortOrder(playbookRedirect.sortOrder || -1)

                }
                let playbookSelectedProduct = localStorage.getItem('quarterlyHuddleConSelectedProduct');


                if (playbookSelectedProduct) {
                    playbookSelectedProduct = JSON.parse(playbookSelectedProduct)
                    setSelectedRowData(playbookSelectedProduct)
                }

                localStorage.removeItem('quarterlyHuddleConSelectedProduct')
                localStorage.removeItem('quarterlyHuddleConRedirect');
                //! --------------------------
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setIsLoading(false);
            });
    };

    //! ----------------------------

    //* ----------------------------
    const getStatus = (rowData) => {
        let status = rowData.status;

        // Mapping status to the display text
        let statusText;
        switch (status) {
            case 'open':
                statusText = 'In Progress';  // Change "open" to "In Progress"
                break;
            case 'close':
                statusText = 'Completed';   // Change "close" to "Completed"
                break;
            case 'pending':
                statusText = 'Pending';     // Keep "pending" as it is
                break;
            default:
                statusText = '';     // Default case if status doesn't match
                break;
        }

        return (
            <Tag value={toProperCase(statusText)} className='p-2'
                style={{
                    backgroundColor: getColorForStatus(status),
                    color: 'white'
                }} />
        );
    };

    // const getStatus = (rowData) => {
    //     var status = rowData.status;

    //     return <Tag value={toProperCase(status)} className='p-2'
    //         style={{
    //             backgroundColor: getColorForStatus(status),
    //             color: 'white'
    //         }} />;
    // };

    const getColorForStatus = (status) => {
        switch (status) {
            case 'open':
                return '#00AC47';

            case 'pending':
                return '#0b2ca1';

            case 'close':
                return '#fc1b5f';

            default:
                return '#CC9A36';
        }
    };
    //! ----------------------------
    //* ----------------------------
    const getPriority = (rowData) => {
        const priority = rowData.priority;
        if (!priority) {
            return null;
        }
        return (
            <Tag value={toProperCase(priority)} className='p-2'
                style={{
                    backgroundColor: getColorForPriority(priority),
                    color: 'white'
                }} />
        );
    };

    const getColorForPriority = (priority) => {
        switch (priority) {
            case 'low':
                return '#536493';
            case 'medium':
                return '#FF9D3D';
            case 'high':
                return '#FC1B5F';
            default:
                return '#CC9A36';
        }
    };

    //! ----------------------------
    //* ----------------------------
    const priorityOptionTemplate = (option) => {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                color: 'white',
                backgroundColor: getColorForPriority(option.value),
                padding: '0.5em',
                borderRadius: '4px',
                margin: '2px 0'
            }}>
                {option.label}
            </div>
        );
    };
    //! ----------------------------
    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined' };

    //* ----------------------------
    const header = (
        <div className="flex flex-wrap align-items-center justify-content-end m-2">
            <span className="flex-grow p-input-icon-left" style={{ order: 1 }}>
                <InputText
                    className="input-field m-2"
                    type="search"
                    placeholder="Search..."
                    value={globalFilterValue}
                    onChange={onGlobalFilterChange}
                />
            </span>
        </div>
    );


    //! ----------------------------
    //* ----------------------------
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(12);
    const [sortField, setSortField] = useState('quater');
    const [sortOrder, setSortOrder] = useState(-1);
    const fetchData = async (event) => {
        const { first, rows, sortField, sortOrder } = event;
        setFirst(first);
        setRows(rows);
        setSortField(sortField);
        setSortOrder(sortOrder);
    }

    const onRowSelect = (e) => {
        const rowData = e.data;
        openEditModal(rowData);
        setSelectedRowData(rowData);
    };

    const handleNavigation = (event) => {
        // const isAdmin = localStorage.getItem('isAdmin'); // Assuming isAdmin is stored in localStorage
        if (orgShow === 'Y') {
            navigate('/help-admin/' + event._id);
        } else {
            // Handle case where user is not an admin, if needed
            toast.current.show({ severity: 'warn', summary: 'Access Denied', detail: 'You do not have admin access.' });
        }
    };

    const openEditModal = (event) => {
        console.log('event-------------------------->', event);

        localStorage.setItem('quarterlyHuddleConRedirect', JSON.stringify({
            rows: rows,
            first: first,
            sortField: sortField,
            sortOrder: sortOrder,
        }))

        localStorage.setItem('quarterlyHuddleConSelectedProduct', JSON.stringify(event))

        // navigate('/help-admin/' + event._id)
        handleNavigation(event);
    };
    //! ----------------------------
    //* ----------------------------
    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        setSelectedFiles(files);
        setTotalSize(totalSize + files.reduce((acc, file) => acc + file.size, 0));
        // setImages([...images, ...files]);
        setImages((prevImages) => [...prevImages, ...files]);
        formik.setFieldValue('images', [...formik.values.images, ...files]);
    };

    const handlePaste = (event) => {
        const items = event.clipboardData.items;
        const files = [];
        for (let i = 0; i < items.length; i++) {
            if (items[i].kind === 'file') {
                const file = items[i].getAsFile();
                if (file && file.type.startsWith('image/')) {
                    files.push(file);
                }
            }
        }
        if (files.length > 0) {
            setImages((prevImages) => [...prevImages, ...files]);
            formik.setFieldValue('images', [...formik.values.images, ...files]);
            toast.current.show({ severity: 'info', summary: 'Success', detail: 'Images pasted successfully' });
        }
    };

    const removeImage = (index) => {
        const updatedImages = images.filter((_, i) => i !== index);
        setImages(updatedImages);
        formik.setFieldValue('images', updatedImages);
    };
    //! ----------------------------

    return (
        <div>
            <Toast ref={toast} />
            <div className='p-4'>
                <form onSubmit={formik.handleSubmit} className='module-card p-2'>
                    <div className='px-2 flex w-full '  >

                        <div className='left p-2 flex flex-wrap' style={{ width: '50%' }}>
                            {/* Row 1 */}
                            <div className=' gap-2 ' style={{ width: '100%' }}>
                                <div >
                                    <h3 className='card-heading'>Issue</h3>
                                    <InputTextarea
                                        id="issue"
                                        name="issue"
                                        rows={2}
                                        value={formik.values.issue}
                                        onChange={(e) => formik.setFieldValue('issue', e.target.value)}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                                <div >
                                    <h3 className='card-heading'>Priority</h3>
                                    <Dropdown
                                        options={priorityOptions}
                                        value={formik.values.priority}
                                        onChange={(e) => formik.setFieldValue('priority', e.target.value)}
                                        placeholder="Select Priority"
                                        itemTemplate={priorityOptionTemplate}
                                        style={{ width: '100%', fontWeight: '600' }}
                                    />
                                </div>
                            </div>

                            <div style={{ width: '100%' }}>
                                <h3 className='card-heading'>Description</h3>
                                <InputTextarea
                                    id="description"
                                    name="description"
                                    rows={5}
                                    value={formik.values.description}
                                    onChange={(e) => formik.setFieldValue('description', e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </div>
                        </div>

                        <div className='right p-2' style={{ width: '50%' }}>
                            <h3 className='card-heading'>Attachment</h3>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                                {/* {images.length === 0 && <h4>please choose image or paste</h4>} */}
                                <input
                                    type="file"
                                    multiple
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    onPaste={handlePaste}
                                    style={{ width: '100%', marginBottom: '5px', backgroundColor: '#608BC1' }}
                                    className='py-1'
                                />
                                {/* Paste Here Box */}
                                <div
                                    style={{
                                        width: '100%',
                                        height: '80px',
                                        border: '2px dashed #ccc',
                                        borderRadius: '5px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        textAlign: 'center',
                                        marginBottom: '10px',
                                        color: '#999',
                                        cursor: 'pointer'
                                    }}
                                    onPaste={handlePaste} // Attach the paste handler here
                                >
                                    <span>Paste Here</span>
                                </div>

                                <div style={{ width: '100%', maxHeight: '200px', overflowY: 'auto', border: '1px solid black' }}>
                                    {images.map((file, index) => (
                                        <div key={index} className="flex align-items-center">
                                            <img alt={file.name} src={URL.createObjectURL(file)} width={70} height={70} />
                                            <span>{file.name}</span>
                                            <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-danger" onClick={() => removeImage(index)} />
                                        </div>
                                    ))}
                                </div>



                            </div>
                        </div>

                    </div>

                    <div className="col-12 pt-0" >
                        <div className="flex  justify-content-center mt-1">
                            <Button label="Submit" type="submit" className='p-2 customSave-button' />
                        </div>
                    </div>
                </form>
            </div>

            <div className="table px-4" >
                <div className="pagee-container mt-2">
                    <Toast ref={toast} />
                    <ConfirmDialog />
                    <div className="pagination-datable-height">
                        {isLoading ? (
                            <div className="loading-spinner">
                                Loading...
                                <div className="spinner"></div>
                            </div>
                        ) : (
                            <DataTable
                                value={orgType}
                                paginator

                                rows={rows}
                                first={first}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                onPage={fetchData}
                                onSort={fetchData}

                                tableStyle={{ minWidth: '50rem' }}
                                selectionMode="single"
                                onRowSelect={onRowSelect}
                                onRowUnselect={onRowSelect}

                                selection={selectedRowData}

                                header={header}

                                filters={filters}
                                filterDisplay="menu"
                                globalFilterFields={['team_member_name', 'supervisor_name', 'date', 'quater', 'year']}
                                emptyMessage="No records found"
                            >


                                <Column field="issue" header="Issue" style={{ width: '250px' }}></Column>
                                <Column field="name" header="Name"  ></Column>
                                <Column field="priority" header="Priority" body={getPriority} style={{ textAlign: 'center' }} ></Column>
                                <Column field="status" header="Status" body={getStatus} style={{ textAlign: 'center' }} />
                                <Column field="opened" header="Opened" />
                                <Column field="fixed" header="Fixed" />
                                <Column field="description" header="Description" ></Column>


                            </DataTable>
                        )}
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Help